/* eslint-disable max-statements */
/* eslint-disable complexity */
import { useMemo } from "react";
import { useSelector } from "react-redux";

const EMPTY_OBJ = {};
const useCarHighlightLocation = (
    cityCode = ""
) => {

    const hubLocations = useSelector((state) => state?.config?.hubLocations || EMPTY_OBJ);

    const carHubDetails = useMemo(() => {
        const isCarHubPresent = Object.keys(hubLocations || {}).find((v) => v === cityCode);
        if (isCarHubPresent) {
            return hubLocations[cityCode];
        }
        return {};
    }, [cityCode, hubLocations]);
    const getHubsInfo = () => {
        const value = Object.keys(hubLocations || []).map((key) => hubLocations[key]);
        return value || [];
    };
    return {currentCarCityInfo: carHubDetails || {}, getHubsInfo};
};

export default useCarHighlightLocation;
